'use client';

import React, { useEffect } from 'react';

import { createPortal } from 'react-dom';
import { BsExclamationCircle } from 'react-icons/bs';
import { FaRegCircleCheck } from 'react-icons/fa6';
import { GoInfo } from 'react-icons/go';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { IoClose } from 'react-icons/io5';

import { userUIStore } from '@/stores/userUIStore';

type AlertType = 'success' | 'error' | 'warning' | 'info';

const Alerts = () => {
  const { Alert, setAlert } = userUIStore();

  useEffect(() => {
    if (Alert.show && Alert.duration) {
      const timer = setTimeout(() => { return setAlert({ ...Alert, show: false }); }, Alert.duration);
      return () => { return clearTimeout(timer); };
    }
    return undefined;
  }, [Alert, setAlert]);

  if (!Alert.show) return null;

  const alertContent = {
    success: {
      title: 'Éxito',
      icon: <FaRegCircleCheck className="text-white text-[24px] w-[24px] min-w-[24px]" />,
      color: 'bg-[#3AB75C]',
      btnColor: 'bg-[#34A358',
    },
    error: {
      title: 'Error',
      icon: <IoMdCloseCircleOutline className="text-white text-[24px] w-[24px] min-w-[24px] " />,
      color: 'bg-[#BF343B]',
      btnColor: 'bg-[#AB2E34]',
    },
    warning: {
      title: 'Alerta',
      icon: <BsExclamationCircle className="text-white text-[24px] w-[24px] min-w-[24px]" />,
      color: 'bg-[#DDA419]',
      btnColor: 'bg-[#AA7E11]',
    },
    info: {
      title: 'Información',
      icon: <GoInfo className="text-white text-[24px] w-[24px] min-w-[24px]" />,
      color: 'bg-[#1897C0]',
      btnColor: 'bg-[#1789AD]',
    },
  } as const;

  const content = alertContent[Alert.type as AlertType];

  return createPortal(
    <div className="fixed inset-0 flex items-center justify-center z-9999">
      <div className="flex  gap-2  rounded-lg shadow-lg bg-linear-to-r from-zinc-800 to-zinc-900 rounded-tr-[10px] rounded-br-[10px]  w-[320px]">
        <div className={` ${content.color} ps-1 rounded-s-lg flex items-center pe-1`}>
          {content.icon}
        </div>
        <div className="flex flex-col text-white py-2">
          <h3 className="font-medium">{content.title}</h3>
          <p className="text-sm">{Alert.message}</p>
        </div>
        <button
          type="button"
          onClick={() => { return setAlert({ ...Alert, show: false }); }}
          className="ml-auto p-2 self-stretch rounded-r-lg "
        >
          <IoClose className="text-white text-xl" />
        </button>
      </div>
    </div>,
    document.body,
  );
};

export default Alerts;
